/* eslint-disable max-len */
import { createAction } from '../utils/createAction';

export const CREATE_PLA_CONFIGURATION = 'Create Pla Configuration';
export const SET_PLA_CONFIGURATION = 'Set Pla Configuration';
export const SET_PLA_CONFIGURATION_COLOR = 'Set Pla Configuration Color';
export const SET_PLA_CONFIGURATION_DETAILS = 'Set Pla Configuration Details';
export const PLA_CONFIGURATION = '[Pla Configuration]';
export const FETCH_PLA_CONFIGURATION_SELECTIONS = 'Fetch Pla Selections';
export const PLA_CONFIGURATION_SELECTIONS = 'Pla Configuration Selections';
export const CREATE_NEW_CONFIGURATION_START = 'Create New Configuration Start';
export const USER_HAS_CHANGED_COLOR = 'Set User Has Changed Color';
export const UPDATE_PLA_CONFIGURED_PRICE = 'Update Pla Configured Price';
export const SET_UPDATED_PLA_CONFIGURED_PRICE = 'Set Updated Pla Configured Price';
export const RESET_STATE_TO_INITIAL = 'Reset State To Initial';

export const createNewConfigurationStart = () => (
  createAction(
    CREATE_NEW_CONFIGURATION_START,
    () => ({}),
  ))();

export const setUserHasChangedColor = (color, userHasChangedColor) => (
  createAction(
    USER_HAS_CHANGED_COLOR,
    () => ({ color, userHasChangedColor }),
  ))();

export const createPlaConfiguration = ({ configurationsApiUrl, apiPayload }) => (
  createAction(
    CREATE_PLA_CONFIGURATION,
    () => (apiPayload),
    () => ({ configurationsApiUrl })
  )
)({ configurationsApiUrl, apiPayload });

export const setPlaConfiguration = (plaConfigurationSettings) => (
  createAction(
    SET_PLA_CONFIGURATION,
    () => (plaConfigurationSettings),
    () => ({})
  )
)(plaConfigurationSettings);

export const setPlaConfigurationColor = (selectedColor) => (
  createAction(
    SET_PLA_CONFIGURATION_COLOR,
    () => (selectedColor),
    () => ({})
  )
)(selectedColor);

export const fetchPlaConfigurationSelections = ({
  customBaseUrl, baseConfigurationIdForSelections, partnerProductId, availableSkus
}) => (
  createAction(
    FETCH_PLA_CONFIGURATION_SELECTIONS,
    () => ({ customBaseUrl }),
    () => ({ baseConfigurationIdForSelections, partnerProductId, availableSkus }),
  )
)({ customBaseUrl, baseConfigurationIdForSelections, partnerProductId, availableSkus });

export const setPlaConfigurationDetails = (
  { plaConfigurationDetails, plaColor, plaConfiguredPrice, plaSquareFootage }
) => (
  createAction(
    SET_PLA_CONFIGURATION_DETAILS,
    () => ({ plaConfigurationDetails, plaColor, plaConfiguredPrice, plaSquareFootage }),
  )
)({ plaConfigurationDetails, plaColor, plaConfiguredPrice, plaSquareFootage });

export const updatePlaConfiguredPrice = (
  color
) => (
  createAction(
    UPDATE_PLA_CONFIGURED_PRICE,
    () => ({ color }),
  )
)({ color });

export const setUpdatedPlaConfiguredPrice = (
  priceDetails
) => (
  createAction(
    SET_UPDATED_PLA_CONFIGURED_PRICE,
    () => ({ priceDetails }),
  )
)({ priceDetails });

export const resetStateToInitial = () => (
  createAction(
    RESET_STATE_TO_INITIAL,
    () => ({}),
  ))();
